<template>
  <div class="credentialsDetail">
    <div class="title">
      <div class="mainTitle">
        <i class="ico_memberV" v-if="userInfo.status === 4"></i>证书一
      </div>
      <Back />
    </div>
    <!-- <div class="memberCover"></div> -->
    <div class="memberTips">
      <div class="content">
        <i class="ico_memberV"></i>
        {{
          userInfo.status === "4"
            ? "您是尊贵的年费会员用户，可以查看访客的姓名手机号以及被查看次数。"
            : `最近有${list.length}个用户查看了您的报告，开通会员看看谁查看了您的报告`
        }}
      </div>
      <button
        class="btn_member"
        @click="dialogBuy = true"
        v-if="userInfo.status !== '4'"
      >
        开通会员>
      </button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      fit
      highlight-current-row
      empty-text=" "
    >
      <el-table-column label="查看时间" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.visitDates[scope.row.visitDates.length - 1]
              | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="查看人" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="已查看次数" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.visitTimes }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="交流互动"
        width="160px"
        align="center"
        v-if="userInfo.status === '4'"
      >
        <template slot-scope="scope">
          <div class="detail" @click="commingSoon">发送联系方式</div>
          <div class="detail" @click="commingSoon">发留言</div>
        </template>
      </el-table-column>
    </el-table>
    <no-data top="-205px" v-if="list.length === 0" />
    <Cover
      :dialogGuide="dialogGuide"
      @dialogGuideClose="handleDialogGuideClose"
    >
      <ul slot="content">
        <li>
          <div>生成个人信息报告：</div>
          <div>
            您可以从数据档案中勾选必要信息生成个人信息报告，通过电子证书授权他人查看。
          </div>
        </li>
        <li>
          <div>生成电子证书：</div>
          <div>每份报告可生成多个电子证书，授权可查看时间段、可查看次数。</div>
        </li>
        <li>
          <div>下载电子证书：</div>
          <div>
            生成的电子证书可通过下载保存证书或者微信直接分享给他人。
          </div>
        </li>
      </ul>
    </Cover>
    <div v-if="dialogBuy">
      <BuyMember
        @handleClose="dialogPaymemberClose"
        subTitle="您正在查看访客信息，立刻开通年费会员，享受更多专属权益"
      >
        <div slot="btn" style="text-align:center">
          <Btn
            btnText="支付完成"
            @handleClick="handlePayDone"
            className="primary"
            :width="120"
            style="margin-top:30px"
          />
        </div>
      </BuyMember>
    </div>
    <CommingSoon ref="commingSoon" />
  </div>
</template>

<script>
import Cover from "@/components/Cover.vue";
import BuyMember from "../../../components/BuyMember.vue";
import { visitRecord } from "@/api/report";
import { getUserInfo } from "@/api/user";
import NoData from "../../../components/NoData.vue";
import Btn from "@/components/Btn.vue";
import Back from "../../../components/Back.vue";
import CommingSoon from "../../../components/CommingSoon.vue";
export default {
  components: { Cover, BuyMember, NoData, Btn, Back, CommingSoon },
  data() {
    return {
      list: [],
      listQuery: {
        id: undefined,
        current: 1
        // pages: 1,
        // size: 10
      },
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      dialogGuide: false,
      listLoading: false,
      dialogBuy: false
    };
  },
  created() {
    this.listQuery.id = this.$route.query.id;
    this.getList();
  },
  methods: {
    getList() {
      visitRecord(this.listQuery).then(res => {
        this.list = res.data.d.records;
      });
    },
    handleDialogGuideClose() {
      this.dialogGuide = !this.dialogGuide;
    },
    handleCredentials() {
      this.$router.push("credentialsList");
    },
    handleDialogBuyClose() {
      this.dialogBuy = false;
    },
    dialogPaymemberClose() {
      this.dialogBuy = false;
    },
    handlePayDone() {
      getUserInfo().then(res => {
        if (res.data.c === 200) {
          sessionStorage.setItem("userInfo", JSON.stringify(res.data.d));
          this.userInfo = res.data.d;
          this.dialogBuy = false;
        }
      });
    },
    commingSoon() {
      this.$refs.commingSoon.handleShow();
    },
  }
};
</script>

<style lang="scss" scope>
.ico_member {
  display: inline-block;
  width: 23px;
  height: 26px;
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/ico_member.png")
    no-repeat;
  background-size: cover;
  margin-right: 17px;
}
.ico_memberV {
  display: inline-block;
  width: 23px;
  height: 26px;
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/ico_memberV.png")
    no-repeat;
  background-size: cover;
  margin-right: 17px;
}
.credentialsDetail {
  position: relative;
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  .memberCover {
    height: 179px;
    width: 100%;
    background: RGBA(250, 239, 227, 0.26);
    position: absolute;
    left: 0;
    top: 0;
  }
  .memberTips {
    background: rgba(211, 175, 118, 0.29);
    color: #ad874c;
    padding: 15px 37px 13px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    .content {
      display: flex;
      align-content: center;
      justify-content: center;
    }
    .btn_member {
      width: 114px;
      height: 38px;
      background: linear-gradient(85deg, #f06c30, #fa4f2d, #fd643c);
      border-radius: 19px;
      color: #fff;
      border: 0;
      font-weight: bold;
    }
  }
  .el-table th.el-table__cell {
    background-color: #f0f2f5;
  }
  .el-table {
    color: #6e6e6e;
  }
  .title {
    margin-bottom: 22px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    .mainTitle {
      display: flex;
      align-items: center;
      &::before {
        content: "";
        border-left: 3px solid #3a61b1;
        padding-right: 10px;
        height: 16px;
        position: relative;
        top: 0px;
      }
      .guide {
        font-size: 14px;
        font-weight: normal;
        color: #6e6e6e;
        display: flex;
        align-items: center;
        .ico_guide {
          background: #ff8d65;
          width: 15px;
          height: 15px;
          display: inline-block;
          border-radius: 15px;
          margin-right: 5px;
          margin-left: 12px;
          font-style: normal;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
  .detail {
    color: #338ff7;
    cursor: pointer;
  }
  .btn_default {
    width: 165px;
    height: 39px;
    border: 1px solid #ddd;
    border-radius: 19.5px;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/report/CredentialsDetail.vue